const saldo = (state) => state.saldo;
const saldoLoading = (state) => state.saldoLoading;

export default {
  saldo,
  saldoLoading,
};
